import React from 'react';

import gogglesButtonCloseView from '../../../main/assets/images/fpvonepilot/gogglesButtonsCloseView.webp';

export const Power = () => {
  return (
    <section className="fpv-pilot-power-section">
      <div className="fpv-pilot-power-content">
        <div className="fpv-pilot-power-text">
          <div className="fpv-pilot-power-titles">
            <h3 className="fpv-pilot-power-subtitle">Power</h3>
            <h2 className="fpv-pilot-power-title">More Power to You</h2>
          </div>
          <div className="fpv-pilot-power-specs">
            <div className="fpv-pilot-power-specification">
              <h3 className="fpv-pilot-power-spec-title">
                Standard receiver bay
              </h3>
              <p className="fpv-pilot-power-spec-description">5V, High power</p>
            </div>
            <div className="fpv-pilot-power-specification">
              <h3 className="fpv-pilot-power-spec-title">barrel connector</h3>
              <p className="fpv-pilot-power-spec-description">
                2.1 x 5.5mm barrel connector
              </p>
            </div>
            <div className="fpv-pilot-power-specification">
              <h3 className="fpv-pilot-power-spec-title">Power supply</h3>
              <p className="fpv-pilot-power-spec-description">
                6-26VDC (2-6S Li-ion Battery)
              </p>
            </div>
            <div className="fpv-pilot-power-specification">
              <h3 className="fpv-pilot-power-spec-title">Secondary bay</h3>
              <p className="fpv-pilot-power-spec-description">5V, SDIO, Uart</p>
            </div>
          </div>
        </div>
        <div className="fpv-pilot-power-image">
          <img
            src={gogglesButtonCloseView}
            alt="Detailed Look at the Controls"
            className="fpv-pilot-power-product"
          />
        </div>
      </div>
    </section>
  );
};
